import styled from "styled-components";

export const TextFieldStyled = styled.div`
  .label {
    margin-bottom: 2px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    span {
      color: ${({ theme }) => theme.COLORS.RED_1};
    }
  }
  input {
    border-radius: 20px;
    border: 1px solid
      ${({ theme, isError }) =>
        isError ? theme.COLORS.RED_1 : theme.COLORS.PURPLE_11};
    padding: 0px 20px;
    width: calc(100% - 40px);
    height: 38px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    color: ${({ theme }) => theme.COLORS.BLACK_4};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    cursor: ${({ disabled }) => (!disabled ? "auto" : "not-allowed")};
    &::placeholder {
      color: ${({ theme }) => theme.COLORS.GRAY_17};
    }
  }
  input:focus {
  }
  .errors {
    margin-top: 2px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  &.theme_standard {
    input {
      &::placeholder {
        color: ${({ theme }) => theme.COLORS.GRAY_10};
      }
    }
  }
  &.theme_standard2 {
    input {
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
  }

  &.theme_placeholder_light {
    input {
      &::placeholder {
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
  }
`;
